import { arrayToKeyValuePairs } from 'shared/utils';

export const EXPENSE_PERIODS = {
  ACTUAL: 'Actual',
  ACTUAL_T12: 'Actual T12',
  ANNUALIZED_HISTORICAL: 'Annualized Historical',
  PROJECTION: 'Projection',
};

export const EXPENSE_PERIOD_KEYS = {
  ACTUAL: 'actual',
  ACTUAL_T12: 'actual-t12',
  ANNUALIZED_HISTORICAL: 'annualized-historical',
  PROJECTION: 'projection',
};

export const EXPENSE_PERIOD_OPTIONS = [
  { value: EXPENSE_PERIOD_KEYS.ACTUAL, label: EXPENSE_PERIODS.ACTUAL },
  { value: EXPENSE_PERIOD_KEYS.ACTUAL_T12, label: EXPENSE_PERIODS.ACTUAL_T12 },
  { value: EXPENSE_PERIOD_KEYS.ANNUALIZED_HISTORICAL, label: EXPENSE_PERIODS.ANNUALIZED_HISTORICAL },
  { value: EXPENSE_PERIOD_KEYS.PROJECTION, label: EXPENSE_PERIODS.PROJECTION },
];

export const EXPENSE_COMPARABLES_CATEGORIES = {
  address: 'address',
  sourceOfInformation: 'sourceOfInformation',
  city: 'city',
  state: 'state',
  expensePeriod: 'expensePeriod',
  expenseYear: 'expenseYear',
  expenseMonth: 'expenseMonth',
  grossBuildingArea: 'grossBuildingArea',
  residentialUnits: 'residentialUnits',
  effectiveGrossIncome: 'effectiveGrossIncome',
  propertyType: 'propertyType',
  yearBuilt: 'yearBuilt',
  realEstateTaxes: 'realEstateTaxes',
  insurance: 'insurance',
  utilities: 'utilities',
  electricity: 'electricity',
  fuel: 'fuel',
  waterAndSewer: 'waterAndSewer',
  repairsAndMaintenance: 'repairsAndMaintenance',
  payrollAndBenefits: 'payrollAndBenefits',
  generalAndAdministrative: 'generalAndAdministrative',
  legalAndProfessionalFees: 'legalAndProfessionalFees',
  miscellaneous: 'miscellaneous',
  managementFees: 'managementFees',
  replacementReserves: 'replacementReserves',
};

export const EXPENSE_COMPARABLES_LABELED_CATEGORIES = {
  [EXPENSE_COMPARABLES_CATEGORIES.address]: 'Address',
  [EXPENSE_COMPARABLES_CATEGORIES.sourceOfInformation]: 'Source Of Information',
  [EXPENSE_COMPARABLES_CATEGORIES.city]: 'City',
  [EXPENSE_COMPARABLES_CATEGORIES.state]: 'State',
  [EXPENSE_COMPARABLES_CATEGORIES.expensePeriod]: 'Expense Period',
  [EXPENSE_COMPARABLES_CATEGORIES.expenseYear]: 'Expense Year',
  [EXPENSE_COMPARABLES_CATEGORIES.expenseMonth]: 'Expense Month',
  [EXPENSE_COMPARABLES_CATEGORIES.grossBuildingArea]: 'SF',
  [EXPENSE_COMPARABLES_CATEGORIES.residentialUnits]: 'Residential Units',
  [EXPENSE_COMPARABLES_CATEGORIES.effectiveGrossIncome]: 'Effective Gross Income',
  [EXPENSE_COMPARABLES_CATEGORIES.propertyType]: 'Property Type',
  [EXPENSE_COMPARABLES_CATEGORIES.yearBuilt]: 'Year Built',
  [EXPENSE_COMPARABLES_CATEGORIES.realEstateTaxes]: 'Real Estate Taxes',
  [EXPENSE_COMPARABLES_CATEGORIES.insurance]: 'Insurance',
  [EXPENSE_COMPARABLES_CATEGORIES.utilities]: 'Utilities',
  [EXPENSE_COMPARABLES_CATEGORIES.electricity]: 'Electricity',
  [EXPENSE_COMPARABLES_CATEGORIES.fuel]: 'Fuel',
  [EXPENSE_COMPARABLES_CATEGORIES.waterAndSewer]: 'Water And Sewer',
  [EXPENSE_COMPARABLES_CATEGORIES.repairsAndMaintenance]: 'Repairs And Maintenance',
  [EXPENSE_COMPARABLES_CATEGORIES.payrollAndBenefits]: 'Payroll And Benefits',
  [EXPENSE_COMPARABLES_CATEGORIES.generalAndAdministrative]: 'General And Administrative',
  [EXPENSE_COMPARABLES_CATEGORIES.legalAndProfessionalFees]: 'Legal And Professional Fees',
  [EXPENSE_COMPARABLES_CATEGORIES.miscellaneous]: 'Miscellaneous',
  [EXPENSE_COMPARABLES_CATEGORIES.managementFees]: 'Management Fees',
  [EXPENSE_COMPARABLES_CATEGORIES.replacementReserves]: 'Replacement Reserves',
};

export const EXPENSE_COMPARABLES_INFO = [
  EXPENSE_COMPARABLES_CATEGORIES.address,
  EXPENSE_COMPARABLES_CATEGORIES.sourceOfInformation,
  EXPENSE_COMPARABLES_CATEGORIES.city,
  EXPENSE_COMPARABLES_CATEGORIES.state,
  EXPENSE_COMPARABLES_CATEGORIES.expensePeriod,
  EXPENSE_COMPARABLES_CATEGORIES.expenseYear,
  EXPENSE_COMPARABLES_CATEGORIES.grossBuildingArea,
  EXPENSE_COMPARABLES_CATEGORIES.residentialUnits,
  EXPENSE_COMPARABLES_CATEGORIES.effectiveGrossIncome,
  EXPENSE_COMPARABLES_CATEGORIES.propertyType,
  EXPENSE_COMPARABLES_CATEGORIES.yearBuilt,
];

export const EXPENSE_RATIO = { name: 'Expense Ratio', key: 'expenseRatio' };

export const TOTAL_OPERATING_EXPENSES = {
  name: 'Total Operating Expenses',
  key: 'expensesTotalGross.total',
};
export const TOTAL_OPERATING_EXPENSES_PER_SF = {
  name: 'Total Operating Expenses Per SF',
  key: 'expensesTotalGross.psf',
};
export const TOTAL_OPERATING_EXPENSES_PER_UNIT = {
  name: 'Total Operating Expenses Per Unit',
  key: 'expensesTotalGross.perUnit',
};

export const TOTAL_OPERATING_EXPENSES_CATEGORIES = [
  TOTAL_OPERATING_EXPENSES.key,
  TOTAL_OPERATING_EXPENSES_PER_SF.key,
  TOTAL_OPERATING_EXPENSES_PER_UNIT.key,
];

export const BASIS_OF_COMPARISON_OPTIONS = {
  GROSS: 'Gross',
  PER_SF: 'Per Square Foot',
  PER_UNIT: 'Per Unit',
};

export const BASIS_TYPES = {
  perUnit: 'perUnit',
  psf: 'psf',
  total: 'total',
  percentOfEGI: 'percentOfEGI',
};

export const BASIS_OF_COMPARISON_ITEMS = [
  { value: BASIS_OF_COMPARISON_OPTIONS.GROSS, label: BASIS_OF_COMPARISON_OPTIONS.GROSS },
  { value: BASIS_OF_COMPARISON_OPTIONS.PER_SF, label: BASIS_OF_COMPARISON_OPTIONS.PER_SF },
  { value: BASIS_OF_COMPARISON_OPTIONS.PER_UNIT, label: BASIS_OF_COMPARISON_OPTIONS.PER_UNIT },
];

export const EXPENSE_PERIOD_VALUES = arrayToKeyValuePairs([
  EXPENSE_PERIODS.ACTUAL,
  EXPENSE_PERIODS.ACTUAL_T12,
  EXPENSE_PERIODS.ANNUALIZED_HISTORICAL,
  EXPENSE_PERIODS.PROJECTION,
]);

export const DEFAULT_EXPENSES_KEYS = {
  realEstateTaxes: 'realEstateTaxes',
  insurance: 'insurance',
  utilities: 'utilities',
  electricity: 'electricity',
  fuel: 'fuel',
  waterAndSewer: 'waterAndSewer',
  repairsAndMaintenance: 'repairsAndMaintenance',
  payrollAndBenefits: 'payrollAndBenefits',
  generalAndAdministrative: 'generalAndAdministrative',
  legalAndProfessionalFees: 'legalAndProfessionalFees',
  miscellaneous: 'miscellaneous',
  managementFees: 'managementFees',
  replacementReserves: 'replacementReserves',
};

export const DEFAULT_EXPENSES_TITLES: { [key in string]: string } = {
  realEstateTaxes: 'Real Estate Taxes',
  insurance: 'Insurance',
  utilities: 'Utilities',
  electricity: 'Electricity',
  fuel: 'Fuel',
  waterAndSewer: 'Water And Sewer',
  repairsAndMaintenance: 'Repairs And Maintenance',
  payrollAndBenefits: 'Payroll And Benefits',
  generalAndAdministrative: 'General And Administrative',
  legalAndProfessionalFees: 'Legal And Professional Fees',
  miscellaneous: 'Miscellaneous',
  managementFees: 'Management Fees',
  replacementReserves: 'Replacement Reserves',
};

export const DEFAULT_EXPENSES = [
  {
    category: DEFAULT_EXPENSES_TITLES.realEstateTaxes,
    key: DEFAULT_EXPENSES_KEYS.realEstateTaxes,
  },
  {
    category: DEFAULT_EXPENSES_TITLES.insurance,
    key: DEFAULT_EXPENSES_KEYS.insurance,
  },
  {
    category: DEFAULT_EXPENSES_TITLES.utilities,
    key: DEFAULT_EXPENSES_KEYS.utilities,
  },
  {
    category: DEFAULT_EXPENSES_TITLES.electricity,
    key: DEFAULT_EXPENSES_KEYS.electricity,
  },
  {
    category: DEFAULT_EXPENSES_TITLES.fuel,
    key: DEFAULT_EXPENSES_KEYS.fuel,
  },
  {
    category: DEFAULT_EXPENSES_TITLES.waterAndSewer,
    key: DEFAULT_EXPENSES_KEYS.waterAndSewer,
  },
  {
    category: DEFAULT_EXPENSES_TITLES.repairsAndMaintenance,
    key: DEFAULT_EXPENSES_KEYS.repairsAndMaintenance,
  },
  {
    category: DEFAULT_EXPENSES_TITLES.payrollAndBenefits,
    key: DEFAULT_EXPENSES_KEYS.payrollAndBenefits,
  },
  {
    category: DEFAULT_EXPENSES_TITLES.generalAndAdministrative,
    key: DEFAULT_EXPENSES_KEYS.generalAndAdministrative,
  },
  {
    category: DEFAULT_EXPENSES_TITLES.legalAndProfessionalFees,
    key: DEFAULT_EXPENSES_KEYS.legalAndProfessionalFees,
  },
  {
    category: DEFAULT_EXPENSES_TITLES.miscellaneous,
    key: DEFAULT_EXPENSES_KEYS.miscellaneous,
  },
  {
    category: DEFAULT_EXPENSES_TITLES.managementFees,
    key: DEFAULT_EXPENSES_KEYS.managementFees,
  },
  {
    category: DEFAULT_EXPENSES_TITLES.replacementReserves,
    key: DEFAULT_EXPENSES_KEYS.replacementReserves,
  },
];

export const EXPENSE_RATIO_ROW = {
  key: 'expenseRatio',
  name: 'Expense Ratio',
};

export const BasisTypes = {
  PER_SF: 'sf',
  PER_UNIT: 'unit',
  PER_ROOM: 'room',
  PER_YEAR: 'year',
};

export const UTILITIES_EXPENSES_MODE = {
  BROKEN_OUT: 'brokenOut',
  COMBINED_ELECTRICITY_AND_FUEL: 'combinedElectricityAndFuel',
  COMBINED_ALL: 'combinedAll',
};

export const ADDITIONAL_EXPENSE_CATEGORIES_KEYS = {
  groundskeeping: 'groundskeeping',
  security: 'security',
  nonRevenueUnits: 'nonRevenueUnits',
  advertisingPromotion: 'advertisingPromotion',
  groundLease: 'groundLease',
  condoAssociationFee: 'condoAssociationFee',
  coOpMaintenanceCharges: 'coOpMaintenanceCharges',
  commonAreaMaintenance: 'commonAreaMaintenance',
  cleaningAndJanitorial: 'cleaningAndJanitorial',
};

export const ADDITIONAL_EXPENSE_CATEGORIES = {
  [ADDITIONAL_EXPENSE_CATEGORIES_KEYS.groundskeeping]: 'Groundskeeping',
  [ADDITIONAL_EXPENSE_CATEGORIES_KEYS.security]: 'Security',
  [ADDITIONAL_EXPENSE_CATEGORIES_KEYS.nonRevenueUnits]: 'Non-Revenue Units',
  [ADDITIONAL_EXPENSE_CATEGORIES_KEYS.advertisingPromotion]: 'Advertising/Promotion',
  [ADDITIONAL_EXPENSE_CATEGORIES_KEYS.groundLease]: 'Ground Lease',
  [ADDITIONAL_EXPENSE_CATEGORIES_KEYS.condoAssociationFee]: 'Condo Association Fee',
  [ADDITIONAL_EXPENSE_CATEGORIES_KEYS.coOpMaintenanceCharges]: 'Co-op Maintenance Charges',
  [ADDITIONAL_EXPENSE_CATEGORIES_KEYS.commonAreaMaintenance]: 'Common Area Maintenance',
  [ADDITIONAL_EXPENSE_CATEGORIES_KEYS.cleaningAndJanitorial]: 'Cleaning and Janitorial',
};

export const ADDITIONAL_EXPENSES_CATEGORIES_LIST = Object.values(ADDITIONAL_EXPENSE_CATEGORIES);

export const EXPENSE_DETAILED_ENTRY_MODE = 'detailed';
export const EXPENSE_SUMMARIZED_ENTRY_MODE = 'summarized';

export const EXPENSE_AMOUNT_INPUT_METHOD = 'amount';
export const EXPENSE_RATIO_INPUT_METHOD = 'ratio';
